<template>
  <div id="footer" class="bg-mid">
    <section class="no-vertical-padding">
      <div class="section-inner">
        <div class="footer-content">
          <ul>
            <li><router-link :to="{ name: 'poll' }">Request a feature</router-link></li>
            <li><router-link :to="{ name: 'contact' }">Contact Us</router-link></li>
            <li><router-link :to="{ name: 'faq' }">FAQ</router-link></li>
            <li><router-link :to="{ name: 'changelog' }">Changelog</router-link></li>
          </ul>
          <p>© {{new Date().getFullYear()}} Common Sphere Inc.</p>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'site-footer',
  data () {
    return {}
  },
  created: function () {},
  computed: {},
  methods: {}
}
</script>
<style src="./footer.styl" lang="stylus" scoped></style>
